import { defer, redirect, ShouldRevalidateFunction } from "react-router-dom";
import RequestStatus from "redux/slices/RequestStatus";
import {
  fetchHiddenCellIds,
  fetchSavedZoom,
  fetchSavedShowMetrics,
  getAppHome,
  getSession,
} from "redux/slices/session";
import store from "redux/store";
import { LoaderFunction } from "react-router-typesafe";
import { fetchFirms } from "redux/slices/client";
import { ExtractedGQLError } from "shared/PatternGraphQLError";

export const appLoader = async () => {
  const awaitPromise = await store
    .dispatch(getAppHome())
    .unwrap()
    .catch(() => redirect("/signin"));
  const awaitSavedZoom = await store.dispatch(fetchSavedZoom()).unwrap();
  const awaitSavedShowMetrics = await store.dispatch(fetchSavedShowMetrics()).unwrap();
  const deferPromise = Promise.all([
    store.dispatch(fetchFirms()).unwrap(),
    store.dispatch(fetchHiddenCellIds()).unwrap(),
  ]);
  return defer({ awaitPromise, awaitSavedZoom, awaitSavedShowMetrics, deferPromise });
};

export const checkSignedInLoader = (async () => {
  return await store
    .dispatch(getSession(true))
    .unwrap()
    .then(() => redirect("/lens"))
    .catch((err: ExtractedGQLError | undefined) => {
      if (!err?.message.toLowerCase().includes("unauthorized")) {
        console.error("getSession failed for reason other than unauthorized", err?.message);
      }
      return null;
    });
}) satisfies LoaderFunction;

export const shouldRevalidateApp: ShouldRevalidateFunction = () => {
  const { session, client } = store.getState();
  return session.status === RequestStatus.SUCCEEDED && client.usersStatus === RequestStatus.SUCCEEDED ? false : true;
};
